import { useEffect, useState } from 'react';
import { FaUserAlt } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import SubHeading from '../../../Components/SubHeading';
import PrayogkartaCard from './components/PrayogkartaCard';
import { fetchWrapper } from '../../../_helpers/fetchWrapper';
import { VscLoading } from 'react-icons/vsc';

function PrayogkartaView() {
  const [loading, setLoading] = useState(false);

  const [totalCount, setTotalCount] = useState([]);

  useEffect(() => {
    const getUserCounts = async () => {
      setLoading(true);
      let response = await fetchWrapper.get('/dashboard');
      setTotalCount(response.data);
      setLoading(false);
    };
    getUserCounts();
  }, []);
  return (
    <div className="card content-section">
      <div className="card-header">
        <div className="mx-2 mt-4">
          <SubHeading id="user" Icon={FaUserAlt} />
        </div>
      </div>
      <hr />
      <div className="card-body">
        {loading ? (
          <div className=" text-center ">
            <VscLoading className="spin " size={'2rem'} />
          </div>
        ) : (
          <div className="row">
            {[
              {
                path: 'super_users',
                title: <FormattedMessage id="super_admin" />,
                number: totalCount.superusers,
                color: 'secondary'
              },
              {
                path: 'cd_admins',
                title: <FormattedMessage id="cd_admins" />,
                number: totalCount.cd_admins,
                color: 'primary'
              },
              {
                path: 'executives',
                title: <FormattedMessage id="executives" />,
                number: totalCount.executives,
                color: 'danger'
              },
              {
                path: 'development_partners',
                title: <FormattedMessage id="development_partners" />,
                number: totalCount.active_dp,
                color: 'warning'
              },
              {
                path: '/admin/rosters/individual_list',
                title: <FormattedMessage id="resource_persons" />,
                number: totalCount.active_rp,
                color: 'success'
              },
              {
                path: 'trainees/list',
                title: <FormattedMessage id="participants" />,
                number: totalCount.active_participant,
                color: 'info'
              }
            ].map((item) => (
              <PrayogkartaCard
                key={item.path}
                title={item.title}
                number={item.number}
                color={item.color}
                path={item.path}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PrayogkartaView;
